import { Box, Typography } from '@material-ui/core'
import { FunctionComponent } from 'react'
//@ts-ignore
import { MainContainer } from 'components/page/containers/MainContainer'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
//@ts-ignore
import { useTheme } from 'styled-components'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useHistory } from 'react-router-dom'
import { usePartnerProfile } from 'pages/profile/hooks/usePartnerProfile'
import { Loader } from 'components/core/loader'
import { useFetchPartnerAdmins } from './hooks/useFetchPartnerAdmins'
import ViewUserItem from './ViewUserItem'
import InfiniteScroll from 'react-infinite-scroll-component'
import { StyledTopTitle } from './style'
import { MobileBackButton } from 'common/atoms/MobileBackButton/MobileBackButton'


const { ThemeProvider } = require('@livechat/ui-kit')

interface ViewPartnerAdminsProps {

}
export const ViewPartnerAdminsPage: FunctionComponent<ViewPartnerAdminsProps> = () => {
  const theme = useTheme()
  const history = useHistory()
  const color1 = theme.colors.accent
  const color2 = theme.colors.accent1
  const { isDevice } = useScreenSizes()
  const { backendUser } = useAuth()
  const { company } = usePartnerProfile()
  const { partnerAdminList: users, getAdminUser, page, setPage } = useFetchPartnerAdmins()
  const fetchMore = async () => {
    await getAdminUser(page + 1)
    setPage(page + 1)
  }
  const totalCount = `${users?.totalCount}`

  return (
    <ThemeProvider theme={{}}>
      {!users && <Loader />}
      {company?.name && users && (
        <MainContainer stickTopBar title={`${company?.name} Admins`} user={backendUser} showAvatar hideFooter={false}>
          <Box
            color={theme.colors.accent1}
            bgcolor={theme.colors.supplementary1}
            height={isDevice ? 'inherit' : 'inherit'}
            borderRadius="15px"
            margin={'5% 3% 3% 3%'}
            justifyContent="center"
            alignItems="center"
            id="scrollableAdmins"
          >
            <InfiniteScroll
              scrollThreshold="100px"
              loader={<Loader />}
              hasMore={parseInt(totalCount) > users?.data.length}
              dataLength={users?.data.length}
              next={() => {
                fetchMore()
              }}
              endMessage={
                <p style={{ textAlign: 'center', color: theme.colors.accent1 }}>
                  {users?.data.length === 0 ? <b>No Admins</b> : <b>No More Admins</b>}
                </p>
              }
            >
              <Box bgcolor={theme.colors.supplementary} borderRadius="1em">
                <StyledTopTitle>
                    <MobileBackButton onClick={() => history.goBack()} />
                    <Box textAlign='center'>
                      <Typography variant="h5">
                        <Box fontWeight="bold" color={theme.colors.accent1} ml="5px">
                          {`${company?.name} Admins`}
                        </Box>
                      </Typography>
                    </Box>
                </StyledTopTitle>
                <Box flexDirection="column" padding="0.5em">
                  {users.data?.map(user => (
                    <Box
                      key={user.id}
                      style={{
                        backgroundColor: theme.colors.bgPrimary,
                        marginBottom: '0.5em',
                        borderRadius: '0.5em'
                      }}
                    >
                      {[
                        {
                          label: 'Name:',
                          value: `${user?.firstname} ${user?.lastname}`,
                          style2: {
                            overflow: 'hidden',
                            maxWidth: '85%',
                            overflowWrap: 'break-word'
                          }
                        },
                        {
                          label: 'Email:',
                          value: user.username,
                          style2: {
                            overflow: 'hidden',
                            maxWidth: '85%',
                            overflowWrap: 'break-word'
                          }
                        },
                        {
                          label: '# of Admin Groups:',
                          value: !!user.roleId ? 1 : 0,
                          onClick: () => {
                            const nextLink = `/${user?.id}/admin`.replace('//', '/')

                            getAdminUser().then(() => isDevice && history.push(nextLink))
                          },
                          style2: {
                            textDecoration: 'underline',
                            color: theme.colors.primary,
                            fontWeight: 700,
                            cursor: 'pointer'
                          }
                        }
                      ].map(userData => (
                        <ViewUserItem {...userData} color1={color1} color2={color2}></ViewUserItem>
                      ))}
                    </Box>
                  ))}
                </Box>
              </Box>
            </InfiniteScroll>
          </Box>
        </MainContainer>
      )}
    </ThemeProvider>
  )
}
